import axios from 'axios';

function logError(error) {
	throw error;
}

const instance = axios.create({
	baseURL: process.env.REACT_APP_API_ENDPOINT,
	timeout: 1000,
});

const instanceAPI = axios.create({
	baseURL: process.env.REACT_APP_API_BACKEND,
});

class ExperiencesService {
	getExperiencesPageData(language) {
		return instance
			.get(`/api/singletons/get/ExperiencesPage?lang=${language}`)
			.then(res => res.data)
			.catch(logError);
	}

	getExperience(language, experienceID = null) {
		return instanceAPI
			.get(`/experience/${experienceID}`, { params: { lang: language } })
			.then(({ data }) => data)
			.catch(e => logError(e));
	}

	getMostPopular(language) {
		return instanceAPI
			.get('experience/most-popular', { params: { lang: language, limit: 4 } })
			.then(({ data }) => data.splice(0, 4))
			.catch(e => logError(e));
	}

	getCategories(language) {
		return instanceAPI
			.get('/category', { params: { lang: language, sort: 'name', sortDirection: 'asc' } })
			.then(({ data }) => {
				const res = [];
				data.map(category => res.push({ label: category.name, value: category.id }));
				return res;
			})
			.catch(e => logError(e));
	}

	getExperiencesByCategories({
		language, experiencesLimit, loaded, toLoad,
	}) {
		return instanceAPI.get('/experience/by-categories', {
			params: {
				lang: language, experiencesLimit, limitPerCategory: 5, loaded, toLoad,
			},
		})
			.then(({ data: { data, metadata } }) => (
				{ data, metadata }
			))
			.catch(e => logError(e));
	}

	getExperiences(lang, skip = 0, limit = 9, filters) {
		const filteredFilters = Object.assign({}, filters);
		filteredFilters.priceMin = filteredFilters.price && filteredFilters.price.min;
		filteredFilters.priceMax = filteredFilters.price && filteredFilters.price.max;
		filteredFilters.date = filteredFilters.date && filteredFilters.date.format();
		delete filteredFilters.price;
		return instanceAPI.get('/experience', {
			params: {
				...filteredFilters, lang, skip: skip - 1, limit,
			},
		})
			.then(({ data: { data, metadata } }) => (
				{ data, metadata: { ...metadata, total: metadata.totalRecords } }
			))
			.catch(e => logError(e));
	}

	getRangePrice() {
		return instanceAPI.get('/experience')
			.then(({ data: { metadata } }) => ({
				min: metadata.minPrice,
				max: metadata.maxPrice,
			}))
			.catch(e => logError(e));
	}
}

export default new ExperiencesService();
